import type { Action } from 'redux'
import type { InvokeDefinition } from '../../signalr/types'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import { setWebSettings, fetchUserPermissionsSuccess } from './actions'
import type { UserPermissions, WebSettings } from './types'

export const getWebSettingsDefinition: InvokeDefinition<
  [],
  WebSettings,
  Action
> = {
  method: 'GetWebSettings',
  strategy: 'switch',
  getParams,
  mapResponse: setWebSettings
}

export const fetchUserPermissionsDefinition: InvokeDefinition<
  [],
  UserPermissions,
  Action
> = {
  method: 'GetUserPermissions',
  getParams,
  mapResponse: fetchUserPermissionsSuccess
}
